import React from "react";
import HomePage from "./app/Home";
import Layout from "./app/Layout";
import PortfolioSidebar from "./components/PortfolioSidebar";
import ProjectPage from "./components/ProjectPage";
import { PORTFOLIO_PROJECTS } from "./data/portfolioProjects";
import CatchEmAll from "./catch-em-all/CatchEmAll";
import CitizensGuideToRavnica from "./citizens-guide-to-ravnica/CitizensGuideToRavnica";
import CharacterSheet from "./character-sheet/CharacterSheet";
import TabletopTools from "./tabletop-tools/TabletopTools";
import ActiveTimeBattle from "./tabletop-tools/ActiveTimeBattle";
import PointBuy from "./tabletop-tools/PointBuy";

export const ROUTES = [
	{
		element: <Layout />,
		children: [
			{
				path: "/",
				element: <HomePage />,
			},
			// Portfolio pages - generated from portfolioProjects data
			...PORTFOLIO_PROJECTS.map(project => ({
				path: project.path,
				element: <>
					<PortfolioSidebar />
					<ProjectPage {...project} />
				</>,
				name: project.name,
				image: project.image,
				isProject: true,
				hide: project.hide,
			})),
		],
	},
	{
		name: "Custom Dashboards — League Of Legends",
		path: "/champion-mastery",
		element: <CatchEmAll />,
		isProject: true,
		image: "/league.jpg",
		hide: true,
	},
	{
		name: "Citizen's Guide to Ravnica",
		path: "/citizens-guide-to-ravnica",
		element: <CitizensGuideToRavnica />,
		isProject: false,
		image: "Citizens Guide Thumbnail.jpg",
		hide: true,
	},
	{
		name: "Character Sheet",
		path: "/character-sheet",
		element: <CharacterSheet />,
		isProject: false,
		image: "Tabletop Tools Thumbnail.jpg",
		hide: true,
	},
	{
		name: "Tabletop Tools",
		path: "/tabletop-tools",
		element: <TabletopTools />,
		isProject: false,
		image: "Tabletop Tools Thumbnail.jpg",
		hide: true,
	},
	{
		path: "/tabletop-tools/active-time-battle",
		element: <ActiveTimeBattle />,
		isProject: false,
		hide: true,
	},
	{
		path: "/tabletop-tools/point-buy",
		element: <PointBuy />,
		isProject: false,
		hide: true,
	},
];
